import { observable, action, makeObservable } from 'mobx';

export class TimeStore {
    fastTime = Date.now();
    slowTime = Date.now();

    constructor() {
        makeObservable(this, {
            fastTime: observable,
            slowTime: observable
        });
    }
}

const timeStore = new TimeStore();

setInterval(
    action(() => {
        timeStore.slowTime = Date.now();
    }),
    100000
);

setInterval(
    action(() => {
        timeStore.fastTime = Date.now();
    }),
    1000
);

export default timeStore;
